import type { FC } from 'react';
import { useLocation } from 'react-router';
import { LoadingIndicator } from '../../../../components/loading-indicator/LoadingIndicator';
import { PageUrl } from '../../../utils/page-url';
import { AccountOneColumnSkeleton } from './AccountOneColumnSkeleton';
import { AccountTwoColumnSkeleton } from './AccountTwoColumnSkeleton';
import { MyAccountSkeleton } from './MyAccountSkeleton';

export const AccountSkeletons: FC = () => {
    const location = useLocation();

    switch (location?.pathname) {
        case PageUrl.ACCOUNT_LOGIN.toString():
        case PageUrl.ACCOUNT_REGISTRATION.toString():
        case PageUrl.TRACK_ORDER.toString():
            return <AccountTwoColumnSkeleton />;
        case PageUrl.ACCOUNT_FORGOT_PASSWORD.toString():
        case PageUrl.ACCOUNT_RESET_PASSWORD.toString():
            return <AccountOneColumnSkeleton />;
        // TODO: This is a skeleton for SG My Account, we should remove when we are no longer redirecting to SG
        case PageUrl.ACCOUNT.toString():
            return <MyAccountSkeleton />;
        default:
            return <LoadingIndicator isLoading />;
    }
};
